import { GA_EVENTS } from '../lib/analytics'
import { toArray } from '@nrk/dh-utils'

export function initializeEventLogger(element, sendGaEvent) {
  function logEvent(e) {
    const section = e.target.closest('section')
    const valgtype = section.getAttribute('data-valgtype')
    const grunndata = section.getAttribute('data-grunndata')
    const modulnavn = section.getAttribute('data-modulnavn')
    switch (e.type) {
      case 'dh-valg-toggle-change':
        if (e.detail.value) {
          sendGaEvent(GA_EVENTS.EXPAND_CLOSE(modulnavn, valgtype, grunndata))
        } else {
          sendGaEvent(GA_EVENTS.EXPAND_OPEN(modulnavn, valgtype, grunndata))
        }
        break

      case 'dh-valg-scroll-button-clicked':
        sendGaEvent(
          GA_EVENTS.SCROLL_BUTTON_CLICKED(modulnavn, valgtype, grunndata, e.detail.direction)
        )
        break

      case 'dh-valg-scroll-active-changed':
        sendGaEvent(
          GA_EVENTS.SCROLL_ACTIVE_CHANGED(modulnavn, valgtype, grunndata, e.detail.nextIndex)
        )
        break

      case 'tabs.toggle': {
        const buttons = toArray(e.target.children) as HTMLElement[]
        const currentIndex = buttons.findIndex(
          button => button.getAttribute('aria-selected') === 'true'
        )
        sendGaEvent(GA_EVENTS.TAB_CHANGE(modulnavn, valgtype, grunndata, currentIndex.toFixed()))
      }
    }
  }

  element.addEventListener('dh-valg-toggle-change', logEvent)
  element.addEventListener('dh-valg-scroll-button-clicked', logEvent)
  element.addEventListener('dh-valg-scroll-active-changed', logEvent)
  element.addEventListener('tabs.toggle', logEvent)
}
